import styled from "@emotion/styled";
import React, {useState} from "react";
import PropTypes from "prop-types";
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Fade from "@material-ui/core/Fade";

const TableRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: ${ props => `repeat(6, 150px)`};
    grid-column-start: 1;
    grid-column-end: 5;
    align-items: center;
    
     &:first-of-type {
        margin-left: ${props => (props.hasIndent) ? "var(--space-s1)" : "0"};
        grid-column-start: 1;
    }
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/800 */
    color: var(--color-gray-800);
`;

const RowActionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-left: 10px;
`;

export const TableCell = styled.span``;


export default function ExpansionPanelTableRowComponent(props) {
    const {tableHeadings, rowData, isSelected, onCheckBoxSelected, hasCheckBox} = props;

    const [anchorRef, setAnchorRef] = useState(undefined);
    const [menuOpen, setMenuOpen] = useState(false);

    const onMoreClick = (e) => {
        setAnchorRef(e.currentTarget);
        setMenuOpen(true);
    };

    const handleMenuClose = () => {

    };

    const handleClose = () => {
        setMenuOpen(false);
        setAnchorRef(null);
    };

    return (
        <>
            {
                <TableRow
                    key="table-row"
                    hasIndent={!hasCheckBox}
                    hasCheckBox={hasCheckBox}
                    columnCount={Object.keys(rowData).length}
                >

                    {
                        tableHeadings.map((column, index) => {
                            return (index === 0)
                                ? (
                                    <div key={index} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                        {
                                            hasCheckBox &&
                                            <Checkbox
                                                value={rowData.id}
                                                checked={isSelected}
                                                onChange={e => onCheckBoxSelected(e, rowData)}
                                                color="primary"
                                                inputProps={{
                                                    'aria-label': 'primary checkbox',
                                                }}
                                            />
                                        }
                                        { React.cloneElement(rowData[column.key], {key: index}) }
                                    </div>
                                ) :
                                <span key={index}> {rowData[column.key]} </span>
                        })
                    }

                    <RowActionWrapper>
                        <IconButton ref={anchorRef} onClick={onMoreClick}>
                            <Icon fontSize="small">more_horiz</Icon>
                        </IconButton>
                        {/*<Popper open={menuOpen} anchorEl={anchorRef.current} role={undefined} transition disablePortal>*/}
                        <Menu
                            anchorEl={anchorRef}
                            keepMounted
                            open={menuOpen}
                            onClose={handleClose}
                            disableAutoFocusItem={true}
                            autoFocus={false}
                            TransitionComponent={Fade}
                        >
                            {rowData.actions}
                        </Menu>
                    </RowActionWrapper>

                </TableRow>
            }
        </>
    )
}

ExpansionPanelTableRowComponent.propTypes = {
    tableHeadings: PropTypes.array,
    rowData: PropTypes.object,
    isSelected: PropTypes.bool,
    hasCheckBox: PropTypes.bool,
    onCheckBoxSelected: PropTypes.func
};
